import {call, put} from "redux-saga/effects";
import {requestCampaignList} from "../requests/campaignReportingService";
import {setLoading, setCampaigns, setError} from "../../slices/campaignReportingSlice"

function* handleFetchCampaignReports(action) {
  const {page, status, frequency, fromDate, toDate} = action.payload
  try {
    yield put(setLoading())
    const response = yield call(() => requestCampaignList(page, status, frequency, fromDate, toDate))
    yield put(setCampaigns(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export {handleFetchCampaignReports}